import React from 'react';
import { SelectPicker, Button, InputNumber } from 'rsuite';

const ControlPanel = ({ 
    departments, 
    users, 
    selectedDepartment, 
    selectedEmployee, 
    onDepartmentChange, 
    onEmployeeChange,
    isSelectionMode,
    selectedDatesCount,
    onEnterSelectionMode,
    onExitSelectionMode,
    onBatchAddSchedule,
    canManage,
    onSetSundayHoliday,
    viewMode,
    onViewModeChange,
    nowDate,
    onDateChange,
    onClearAllSchedules
}) => {
    const currentYear = nowDate.getFullYear();
    const currentMonth = nowDate.getMonth() + 1;
    
    const handleYearChange = (year) => {
        const newDate = new Date(year, currentMonth - 1, 1);
        onDateChange(newDate);
    };
    
    const handleMonthChange = (month) => {
        const newDate = new Date(currentYear, month - 1, 1);
        onDateChange(newDate);
    };
    
    return (
        <div className='work-schedule-header'>
            <div className="title">工作班表</div>
            <div className="controls">
                <label>年份：</label>
                <InputNumber
                    value={currentYear}
                    onChange={handleYearChange}
                    min={2020}
                    max={2100}
                    style={{ width: 100 }}
                />
                <label style={{ marginLeft: 10 }}>月份：</label>
                <SelectPicker
                    data={Array.from({ length: 12 }, (_, i) => ({
                        label: `${i + 1}月`,
                        value: i + 1
                    }))}
                    value={currentMonth}
                    onChange={handleMonthChange}
                    cleanable={false}
                    style={{ width: 100 }}
                    menuStyle={{ zIndex: 1050 }}
                />
                <label style={{ marginLeft: 20 }}>部門：</label>
                <SelectPicker
                    data={[
                        { label: '（全部）', value: null },
                        ...departments.map(dept => ({ label: dept.name, value: dept.id }))
                    ]}
                    value={selectedDepartment}
                    onChange={onDepartmentChange}
                    placeholder="選擇部門"
                    cleanable={false}
                    style={{ width: 200 }}
                    menuStyle={{ zIndex: 1050 }}
                />
                <label style={{ marginLeft: 20 }}>員工：</label>
                <SelectPicker
                    data={[
                        { label: '（全部）', value: null },
                        ...users.map(user => ({ label: user.name, value: user.uuid }))
                    ]}
                    value={selectedEmployee}
                    onChange={onEmployeeChange}
                    placeholder="選擇員工"
                    cleanable={false}
                    style={{ width: 200 }}
                    menuStyle={{ zIndex: 1050 }}
                />
                
                <div style={{ marginLeft: 20, display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <Button 
                        appearance={viewMode === 'table' ? 'primary' : 'default'}
                        onClick={() => onViewModeChange('table')}
                        size="sm"
                    >
                        表格視圖
                    </Button>
                    <Button 
                        appearance={viewMode === 'calendar' ? 'primary' : 'default'}
                        onClick={() => onViewModeChange('calendar')}
                        size="sm"
                    >
                        日曆視圖
                    </Button>
                </div>
                {canManage && (
                    <div style={{ marginLeft: 20, display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {!isSelectionMode ? (
                            <>
                                <Button 
                                    appearance="primary" 
                                    onClick={onEnterSelectionMode}
                                    size="sm"
                                >
                                    選取
                                </Button>
                                <Button 
                                    appearance="default" 
                                    onClick={onSetSundayHoliday}
                                    size="sm"
                                    style={{ backgroundColor: '#ff9800', borderColor: '#ff9800', color: 'white' }}
                                >
                                    替所有成員設定週日例假日
                                </Button>
                                <Button 
                                    appearance="default" 
                                    onClick={onClearAllSchedules}
                                    size="sm"
                                    style={{ backgroundColor: '#f44336', borderColor: '#f44336', color: 'white' }}
                                >
                                    清除全部
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button 
                                    appearance="subtle" 
                                    onClick={onExitSelectionMode}
                                    size="sm"
                                >
                                    取消
                                </Button>
                                <Button 
                                    appearance="primary" 
                                    onClick={onBatchAddSchedule}
                                    disabled={selectedDatesCount === 0}
                                    size="sm"
                                >
                                    新增班表 ({selectedDatesCount})
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ControlPanel;
